<script setup lang="ts">

import Concierge from '@presentation/Icons/Concierge.vue';
import { usePresentation } from '@presentation/Types';

const presentation = usePresentation();

</script>

<template>

    <Page>

        <ImageAndText 
            src="/WhatIsCarbucks/concierge.png"
            image-class="max-w-[300px] drop-shadow-xl"
            animation="slide-up"
            flip
            floor-shadow>

            <div class="scale-90 -mx-8">

                <Animated :delay="500" :duration="500" animation="slide-left">
                    <Concierge />
                </Animated>

                <h1 class="my-4">VIP Concierge</h1>

                <p class="font-normal text-white/80">
                    Gives the customer personalised support to help them book their vehicle 
                    in for servicing, get answers to their questions, and assist 
                    with managing repair claims—quickly and easily.
                </p>

                <Triggered animation="push-up">
                    <h2 class="mt-6 2xl:mt-8 uppercase text-emerald-500">... And For Dealers</h2>
                    <p class="font-normal text-white/80">
                        We bridge the gap between data and action. Our Concierge team actively 
                        contacts your customers on your behalf to secure bookings and follow through, 
                        ensuring no service opportunity is missed.
                    </p>
                </Triggered>
            </div>

        </ImageAndText>

    </Page>

</template>